<div class="sidebar-Wrapper">
  <div *ngIf="isMobileMenu()">
    <ul class="nav navbar-nav nav-mobile-menu">
      <li
        *ngFor="let menuItem of menuItems"
        class="{{ menuItem.class }} nav-item"
      >
        <ng-container
          *ngIf="
            menuItem.title == 'Products' ||
              menuItem.title == 'Manage Users' ||
              menuItem.title == 'Providers';
            else accessible
          "
        >
          <span *hideIfUnauthorized="menuItem.title">
            <a
              class="nav-link"
              [routerLink]="[menuItem.path]"
              routerLinkActive="router-link-active"
            >
              <i class="material-icons">{{ menuItem.icon }}</i>
              <p translate>{{ menuItem.translatetitle }}</p>
            </a>
          </span>
        </ng-container>
        <ng-template #accessible>
          <a
            class="nav-link"
            [routerLink]="[menuItem.path]"
            routerLinkActive="router-link-active"
          >
            <i class="material-icons">{{ menuItem.icon }}</i>
            <p translate>{{ menuItem.translatetitle }}</p>
          </a>
        </ng-template>
      </li>

      <li class="nav-item">
        <a class="nav-link cur-point" [routerLink]="['contact-us']">
          <i class="material-icons">connect_without_contact</i>
          <p translate>pages.sidebar.contactUs</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link cur-point" [routerLink]="['terms-conditions']">
          <i class="material-icons">wysiwyg</i>
          <p translate>pages.sidebar.termsConditions</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link cur-point" (click)="onLogout()">
          <i class="material-icons">logout</i>
          <p translate>{{ 'pages.placeholders.Logout' | translate }}</p>
        </a>
      </li>
    </ul>
  </div>
  <ul class="nav" *ngIf="!isMobileMenu()">
    <li
      *ngFor="let menuItem of menuItems"
      class="{{ menuItem.class }} nav-item"
    >
      <ng-container
        *ngIf="
          menuItem.title == 'Products' ||
            menuItem.title == 'Manage Users' ||
            menuItem.title == 'Providers';
          else accessible
        "
      >
        <span *hideIfUnauthorized="menuItem.title">
          <a
            class="nav-link"
            [routerLink]="[menuItem.path]"
            routerLinkActive="router-link-active"
          >
            <i class="material-icons">{{ menuItem.icon }}</i>
            <p translate>{{ menuItem.translatetitle }}</p>
          </a>
        </span>
      </ng-container>
      <ng-template #accessible>
        <a
          class="nav-link"
          [routerLink]="[menuItem.path]"
          routerLinkActive="router-link-active"
        >
          <i class="material-icons">{{ menuItem.icon }}</i>
          <p translate>{{ menuItem.translatetitle }}</p>
        </a>
      </ng-template>
    </li>

    <li class="nav-item">
      <a
        class="nav-link cur-point"
        [routerLink]="['contact-us']"
        routerLinkActive="router-link-active"
      >
        <i class="material-icons">connect_without_contact</i>
        <p translate>pages.sidebar.contactUs</p>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link cur-point"
        [routerLink]="['terms-conditions']"
        routerLinkActive="router-link-active"
      >
        <i class="material-icons">wysiwyg</i>
        <p translate>pages.sidebar.termsConditions</p>
      </a>
    </li>
  </ul>
  <ul class="list-inline sidebar-social">
    <li class="list-inline-item">
      <a href="{{ facebookUrl }}" target="_blank">
        <i class="icon ion-logo-facebook"></i>
      </a>
    </li>

    <li class="list-inline-item">
      <a href="{{ instagramUrl }}" target="_blank">
        <i class="icon ion-logo-instagram"></i>
      </a>
    </li>
  </ul>
</div>
